enum HuonekorttiStatusEnum {
    Tyo = "Työ",
    Julkaistu = "Julkaistu",
    Odottaa = "Odottaa",
    Hyvaksytty = "Hyväksytty",
}

export default HuonekorttiStatusEnum
